module.exports = __webpack_public_path__ + "static/media/Icon_Tow_Truck.6839c17d.svg";